<template>
  <v-container fluid class="card-planta mt-14" :key="componentKey">
    <v-row
      v-for="(itemPlanta, i) in plantWithDemands"
      :key="i + itemPlanta.cdPlantaAbate"
      class="mx-0 pa-0 card-item-planta d-flex flex-column flex-nowrap"
    >
      <v-row class="ma-0 flex-nowrap">
        <v-col class="pa-0 ma-0 colunm-1-dados-lote" cols="2">
          <v-item-group class="pa-2">
            <v-item>
              <v-layout row justify-center ma-0>
                <v-flex lg11>
                  <span class="text-planta-abate">Planta de Abate</span>
                  <br />
                  <span
                    class="text-planta-abate-sif-not-filled"
                  >SIF {{ itemPlanta.plantaAbate.nrRegistroSif }}</span>
                  <br />
                  <span class="text-planta-abate-municipio">
                    {{
                      itemPlanta.plantaAbate.nmMunicipio
                    }}
                  </span>
                  <br />
                  <div class="container-fluid">
                    <v-btn
                      v-if="!itemPlanta.showLotes"
                      class="btn-adicionar-lotes mt-2"
                      @click="changeShowLotes(itemPlanta)"
                    >Visualizar Períodos
                    </v-btn>
                    <v-btn
                      v-else
                      class="btn-adicionar-lotes mt-2"
                      @click="changeShowLotes(itemPlanta)"
                    >Esconder Períodos
                    </v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </v-item>
          </v-item-group>
        </v-col>
        <v-col
          v-for="(itemData, i) in listDatesWithDemand"
          :key="i + itemData.value"
          cols="2"
          class="pa-2 ma-0 colunm-2-dados-lote"
        >
          <CardItensIniciaisCarregamentoPlanta
            :itemPlanta="itemPlanta"
            :itemData="itemData"
            :listaLotesFiltradaDataPlanta="listFilteredLotsByPlant[itemPlanta.cdPlantaAbate]"
          />
        </v-col>
      </v-row>
      <v-row
        v-if="itemPlanta.showLotes"
        v-for="(itemPeriodo, i) in listaPeriodos"
        :key="i + itemPeriodo.dsPeriodo"
        class="ma-0 card-periodo-preenchimento flex-nowrap"
      >
        <v-col class="pa-0 ma-0 period colunm-1-dados-lote" cols="2">
          <v-layout>
            <v-flex lg12>
              <span
                v-if="itemPeriodo.dsPeriodo"
                class="text-card-periodo-preenchido"
              >{{ itemPeriodo.dsPeriodo }}</span>
              <span v-else class="text-card-periodo-preenchido">Período não informado</span>
            </v-flex>
          </v-layout>
        </v-col>
        <v-col
          v-for="(itemData) in listDatesWithDemand"
          :key="`${itemData.value}-card-carregamento-column`"
          cols="2"
          class="pa-0 ma-0 colunm-2-dados-lote"
        >
          <v-item-group>
            <v-item>
              <v-layout>
                <v-flex lg12>
                  <CardCarregamentoColumn
                    :itemData="itemData"
                    :itemPlanta="itemPlanta"
                    :listaLotesFiltradaDataPlanta="listFilteredLotsByPlant[itemPlanta.cdPlantaAbate][itemPeriodo.dsPeriodo][itemData.text]"
                    @forceRerender="forceRerender"
                  />
                </v-flex>
              </v-layout>
            </v-item>
          </v-item-group>
        </v-col>
      </v-row>
      <v-row class="ma-0 flex-nowrap">
        <v-col class="ma-0 pa-0 card-lotes-confirmados colunm-1-dados-demanda" cols="2">
          <v-item-group class="pl-3 pt-3">
            <v-item>
              <span class="text-demanda-plantas">Períodos informados</span>
            </v-item>
          </v-item-group>
        </v-col>
        <v-col
          v-for="(itemData) in listDatesWithDemand"
          :key="`${itemData.value}-card-carregamento-periodo`"
          cols="2"
          class="ma-0 pa-0 card-lotes-confirmados colunm-2-dados-demanda"
        >
          <v-item-group class="pt-3">
            <v-item>
              <v-layout row justify-center>
                <v-flex lg12>
                  <CardItemLotesPeriodoSelecionado
                    :itemData="itemData"
                    :itemPlanta="itemPlanta"
                    :listaLotesFiltradaDataPlanta="listFilteredLotsByPlant[itemPlanta.cdPlantaAbate]"
                  />
                </v-flex>
              </v-layout>
            </v-item>
          </v-item-group>
        </v-col>
      </v-row>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex"

import CardCarregamentoColumn from "@/modules/programacaoAbate/components/CardCarregamentoColumn"
import CardItemLotesPeriodoSelecionado from "@/modules/programacaoAbate/components/CardItemLotesPeriodoSelecionado"
import CardItensIniciaisCarregamentoPlanta
  from "@/modules/programacaoAbate/components/CardItensIniciaisCarregamentoPlanta"

import {daysBetweenDates} from "@/filters/utils"

export default {
  name: "ItemPlantaAbateProgramacaoCarregamento",
  components: {
    CardCarregamentoColumn,
    CardItemLotesPeriodoSelecionado,
    CardItensIniciaisCarregamentoPlanta,
  },
  computed: {
    ...mapState("programacaoAbate", [
      "listaDatas",
      "listDatesWithDemand",
      "listaDemandasPlanta",
      "listBatchsAllocated",
      "listCheckListAlocados",
    ]),
    plantWithDemands() {
      return this.listaDemandasPlanta.filter((item) => item.qtTotalDemanda)
        .sort((a, b) => a.plantaAbate.idPlantaAbate - b.plantaAbate.idPlantaAbate)
    },
    listFilteredLotsByPlant() {
      if (!this.listBatchsAllocated) return {}
      const listaLotesFiltradaDataPlanta = {}
      this.listaDemandasPlanta.forEach((itemPlanta) => {
        let totalAnimaisAlocadoDiaPlanta = 0
        let listaFiltradaDataPeriodo = {}
        
        this.listaPeriodos.forEach((periodo) => {
          let listaCalculada = this.listBatchsAllocated.map((entry) => {
            let dataAlocado = this.listaDatas.find(
              (x) => x.value === entry.stDiaAlocado
            )
            let nrDiasAlojado = this.daysBetweenDates(
              dataAlocado.text,
              "DD/MM/YYYY",
              entry.loteProducao.dtAlojamento,
              "YYYYY-MM-DD"
            )
            let checkList = this.listCheckListAlocados.find(
              (x) =>
                x.cdProgramacaoAbateAlocado === entry.idProgramacaoAbateAlocado
            )
            return {...entry, nrDiasAlojado, checkList}
          })
          
          let listaFiltrada = listaCalculada
            .filter((x) => x.cdPlantaAbate == itemPlanta.cdPlantaAbate)
            .filter(
              (y) =>
                y.checkList &&
                y.checkList.stAbatePeriodo == periodo.dsPeriodo
            )
          
          listaFiltrada.forEach((item) => {
            totalAnimaisAlocadoDiaPlanta =
              parseInt(totalAnimaisAlocadoDiaPlanta) + item.qtAnimaisAlocados
          })
          
          let listaFiltradasDatas = {}
          this.listDatesWithDemand.forEach(function (itemData) {
            listaFiltradasDatas[itemData.text] = listaFiltrada.filter(
              (x) => x.stDiaAlocado === itemData.value
            )
          })
          
          listaFiltradaDataPeriodo[periodo.dsPeriodo] = listaFiltradasDatas
        })
        listaLotesFiltradaDataPlanta[
          itemPlanta.cdPlantaAbate
          ] = listaFiltradaDataPeriodo
      })
      return listaLotesFiltradaDataPlanta
    },
    listaPeriodos() {
      if (this.$keycloak.tokenParsed["PARTNERID"] === 4) {
        return [
          {
            dsPeriodo: null,
          },
          {
            dsPeriodo: "1º Abate da manhã",
          },
          {
            dsPeriodo: "2º Abate da manhã",
          },
          {
            dsPeriodo: "Manhã toda",
          },
          {
            dsPeriodo: "1º Abate da tarde",
          },
          {
            dsPeriodo: "2º Abate da tarde",
          },
          {
            dsPeriodo: "Tarde toda",
          },
        ]
      } else {
        return [
          {
            dsPeriodo: null,
          },
          {
            dsPeriodo: "1º Abate da manhã",
          },
          {
            dsPeriodo: "2º Abate da manhã",
          },
          {
            dsPeriodo: "1º Abate da tarde",
          },
          {
            dsPeriodo: "2º Abate da tarde",
          },
        ]
      }
    }
  },
  data() {
    return {
      listaLotesFiltradaDataPlanta: {},
      componentKey: 0,
    }
  },
  props: {},
  methods: {
    ...mapActions("programacaoAbate", [
      "ActionChangeShowLote",
      "ActionLoadDistanciaPlantaAbateEstabelecimento",
      "ActionLoadCheckList",
    ]),
    daysBetweenDates,
    changeShowLotes(itemLote) {
      this.ActionChangeShowLote(itemLote)
      this.forceRerender()
    },
    forceRerender() {
      this.componentKey += 1
    },
  },
}
</script>

<style>
.text-card-periodo-preenchido {
  text-align: left;
  font: bold 12px Roboto;
  letter-spacing: 0px;
  color: #7b9596;
  opacity: 1;
}
</style>
